import React from 'react';
import PropTypes from 'prop-types';

import { validate } from 'Data/stories/StoryValidators.js';

import Modal from "UI/Modal";
import Button from "UI/Button";
import TextField from "UI/Form/TextField";

import Form from "Components/Form/Form";
import ProjectListSelect from "Components/ProjectListSelect";

export default class CreateStoryDialog extends React.Component
{
    state = {
        projects: [],

        busy: false,
        failed: false,
    };

    static propTypes = {
        accountId: PropTypes.string.isRequired,
        projects: PropTypes.object.isRequired,
        createStory: PropTypes.func.isRequired,
        onClose: PropTypes.func.isRequired,
    };

    onSubmit = (data) => {
        this.setState({busy: true});

        this.props.createStory(
            this.props.accountId,
            data.name,
            data.description,
            this.state.projects
        ).then(
            story => {
                this.props.history.push(`/stories/${story.id}/edit`);
            },
            error => {
                this.setState({busy: false});
            }
        );
    };

    onClose = () => {
        validate.reset();
        this.props.onClose();
    };

    handleChangeProject = (id, on) => {
        if (on) {
            this.setState({
                projects: [
                    ...this.state.projects,
                    id
                ]
            });

            return;
        }

        this.setState({
            projects: this.state.projects.filter(
                project => project !== id
            )
        });
    };

    render()
    {
        const {open} = this.props;

        return <Modal open={open} onClose={this.onClose} className="w-full max-w-xs">
            <Modal.Header>
                Create Story
            </Modal.Header>
            <Modal.Content className='space-y-6'>
                <Form id='create-story' validate={validate} onSubmit={this.onSubmit}>
                    {(data, onChange, validation) =>
                        <>
                            <div className='flex-1 space-y-4'>
                                <TextField
                                    id="name"
                                    label="Story title"
                                    value={data.name || ''}
                                    onChange={onChange('name')}
                                    autoComplete="off"
                                    error={validation.hasErrors('name')}
                                    help={validation.getErrors('name')}
                                />
                                <TextField
                                    id="description"
                                    label="Story description"
                                    value={data.description || ''}
                                    onChange={onChange('description')}
                                    autoComplete="off"
                                    error={validation.hasErrors('description')}
                                    help={validation.getErrors('description')}
                                />
                            </div>

                            <div className='flex-1'>
                                <div className='flex justify-between text-gray-700'>
                                    <label className="block text-sm font-medium leading-5 mb-2">Projects</label>
                                </div>
                                {
                                    <ProjectListSelect
                                        projects={this.props.projects}
                                        selected={this.state.projects}
                                        onChange={this.handleChangeProject}
                                    />
                                }
                            </div>
                        </>
                    }
                </Form>
            </Modal.Content>
            <Modal.Footer>
                <Button form='create-story' type="primary" busy={this.state.busy}>Create Story</Button>
                <Button onClick={this.onClose}>Cancel</Button>
            </Modal.Footer>
        </Modal>;
    }
}
